import { round, forEach, parseInt } from 'lodash'
import { enumclass } from './enumclass'

const PaymentStatus = enumclass({
  INIT: 1000, // 未就绪
  INIT_REQUEST_ERROR: 1001, // 支付请求失败

  UNPAID: 1100, // 待支付
  UNPAID_CHECK_ERROR: 1101, // 待支付状态查单失败
  UNPAID_CHECK_MISMATCH: 1102, // 待支付状态查单金额不对

  PAID: 1200, // 已支付-简易流程

  CONFIRMED: 1300, // 已确认
  CONFIRMED_BY_SUBMIT: 1301, // 用户submit查单确认
  CONFIRMED_BY_CANCEL: 1302, // 用户cancel查单确认
  CONFIRMED_BY_NOTIFY: 1303, // 支付回调查单确认
  CONFIRMED_BY_ADMIN: 1304, // 后台管理员确认
  CONFIRMED_BY_TIMEOUT: 1305, // 超时查单确认

  CANCELED: 1400, // 已取消
  CANCELED_BY_CUSTOMER: 1401, // 用户查单取消
  CANCELED_BY_TIMEOUT: 1402, // 超时查单取消
  CANCELED_BY_ADMIN: 1403, // 管理员查单取消
  CANCELED_BY_ERROR: 1404, // 无法正常支付取消

  REVERTED: 1500, // 已撤销-简易流程

  REFUNDED: 1600, // 已退款
})
PaymentStatus.isSubStatus = function isSubStatus(value) {
  return value % 100 !== 0
}

const PaymentChannelType = enumclass({
  STANDARD_MOCK: 11000, // Mock
  STANDARD_HUPIJIAO_WEIXIN: 11100, // 虎皮椒-微信
  STANDARD_HUPIJIAO_ALIPAY: 11200, // 虎皮椒-支付宝
  STANDARD_WEIXIN_V3: 11300, // 微信支付V3接口
  STANDARD_ALIPAY: 11400, // 支付宝接口

  SIMPLE_MOCK: 21000, // Mock
  SIMPLE_WEIXIN: 21100, // 简易-微信
  SIMPLE_ALIPAY: 21200, // 简易-支付宝
  SIMPLE_BITCOIN: 21300, // 简易-比特币
  PAYPAL_ME: 21400, // PayPal.Me
})
PaymentChannelType.isStandard = function isStandard(channel) {
  return round(channel / 10000) === 1
}
PaymentChannelType.isHupijiao = function isHupijiao(channel) {
  return PaymentChannelType.nameOf(channel).indexOf('HUPIJIAO') >= 0
}
PaymentChannelType.isWeixin = function isWeixin(channel) {
  return PaymentChannelType.nameOf(channel).indexOf('WEIXIN') >= 0
}
PaymentChannelType.isAlipay = function isAlipay(channel) {
  return PaymentChannelType.nameOf(channel).indexOf('ALIPAY') >= 0
}
PaymentChannelType.isSimpleWeixinAlipay = function isSimpleWeixinAlipay(channel) {
  return (
    !PaymentChannelType.isStandard(channel) &&
    (PaymentChannelType.isWeixin(channel) || PaymentChannelType.isAlipay(channel))
  )
}
PaymentChannelType.isBitcoin = function isBitcoin(channel) {
  return PaymentChannelType.nameOf(channel).indexOf('BITCOIN') >= 0
}

const PAYMENT_CHANNEL_TYPES = [
  [PaymentChannelType.STANDARD_WEIXIN_V3, '微信支付V3'],
  [PaymentChannelType.STANDARD_ALIPAY, '支付宝'],
  [PaymentChannelType.STANDARD_HUPIJIAO_WEIXIN, '虎皮椒-微信'],
  [PaymentChannelType.STANDARD_HUPIJIAO_ALIPAY, '虎皮椒-支付宝'],
  [PaymentChannelType.SIMPLE_WEIXIN, '简易-微信'],
  [PaymentChannelType.SIMPLE_ALIPAY, '简易-支付宝'],
  [PaymentChannelType.SIMPLE_BITCOIN, '简易-比特币'],
  [PaymentChannelType.PAYPAL_ME, 'PayPal.Me'],
]

export const paymentChannelTypeList = []
const paymentChannelTypeMap = {}
forEach(PAYMENT_CHANNEL_TYPES, ([key, value]) => {
  paymentChannelTypeList.push({ text: value, value: parseInt(key) })
  paymentChannelTypeMap[key] = value
})

export function getPaymentChannelTypeName(key) {
  return paymentChannelTypeMap[key] || key
}

const PaymentCheckScene = enumclass({
  NOTIFY: 10,
  SUBMIT: 11,
  CANCEL: 12,
  TIMEOUT: 13,
  ADMIN: 14,
  ERROR_CANCEL: 15,
})

const PriceCurrency = function PriceCurrency(name, unit) {
  return { name, unit }
}
PriceCurrency.CNY = PriceCurrency('CNY', 100)
PriceCurrency.USD = PriceCurrency('USD', 100)
PriceCurrency.BTC = PriceCurrency('BTC', 100_000_000)

export { PaymentStatus, PaymentChannelType, PaymentCheckScene, PriceCurrency }

export const EquityPattern = enumclass({
  SUBSCRIPTION: 1, // 订阅模式或永久模式
  CONSUMABLE: 2, // 积分模式/消耗品
  PROMOTER: 3, // 推广员模式
})

export const PaymentDeviceType = enumclass({
  DESKTOP: 1000, // 电脑端
  MOBILE: 1100, // 手机网站
  APP: 1200, // 手机APP
  WEIXIN: 1300, // 手机微信
})
